module.exports = __webpack_public_path__ + "img/about.878e5784.jpg";